import { createFileRoute } from '@tanstack/react-router';

import { GetStartedPage } from '../../features/onboarding/components/GetStartedPage';
import { sanitizeRedirectPath } from '../../features/onboarding/get-started-redirect';

export interface GetStartedSearch {
  redirect?: string;
}

export const Route = createFileRoute('/_onboarding/get-started')({
  component: GetStartedPage,
  validateSearch: (search: Record<string, unknown>): GetStartedSearch => ({
    redirect: sanitizeRedirectPath(search.redirect),
  }),
});
